module.exports = __webpack_public_path__ + "static/media/Kala Simmons_1699528218913.e53c429c.png";